import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useForm } from 'react-hook-form';
import { ServiceAvatar } from './columns';
import RenderAvatarSvg from './render-avatar-svg';

interface AvatarFormProps {
  onSubmit: (data: ServiceAvatar) => void;
  onCancel: () => void;
  initialData?: ServiceAvatar;
}

export function AvatarForm({ onSubmit, onCancel, initialData }: AvatarFormProps) {
  const { register, handleSubmit, watch, setValue } = useForm<ServiceAvatar>({
    defaultValues: initialData || {
      shape: 'square',
      color1: '#ffe2d6',
      color2: '#fff4f0',
    },
  });

  const shape = watch('shape');
  const color1 = watch('color1');
  const color2 = watch('color2');

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="grid grid-cols-2 gap-4 items-center">
        {/* First Row: Avatar Preview and Shape Select */}
        <div className="flex justify-center">
          <RenderAvatarSvg shape={shape} color1={color1} color2={color2} size={100} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="shape">Shape</Label>
          <Select value={shape} onValueChange={value => setValue('shape', value)}>
            <SelectTrigger>
              <SelectValue placeholder="Select shape" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="square">Square</SelectItem>
              <SelectItem value="halfTriangle">Triangle</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Second Row: Color Inputs */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="color1">Primary Color</Label>
          <div className="flex gap-2">
            <Input id="color1" type="color" className="w-[60px] p-1 h-10" {...register('color1')} />
            <Input
              type="text"
              value={color1}
              onChange={e => setValue('color1', e.target.value)}
              className="font-mono"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="color2">Secondary Color</Label>
          <div className="flex gap-2">
            <Input id="color2" type="color" className="w-[60px] p-1 h-10" {...register('color2')} />
            <Input
              type="text"
              value={color2}
              onChange={e => setValue('color2', e.target.value)}
              className="font-mono"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-4 pt-4">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">{initialData ? 'Save Changes' : 'Create'}</Button>
      </div>
    </form>
  );
}
